import Request from './request';

export default class AuthApi {
  static async getToken(data) {
    return Request.post('/oauth/token', data);
  }

  static async getProfile(token) {
    Request.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    return Request.get('/oauth/userinfo');
  }
}
